import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const BillingDashboard = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Billing & Usage Dashboard
        </Typography>
        <Typography variant="body2" color="textSecondary">
          View usage summary, billing history, and download reports
        </Typography>
        {/* Add billing dashboard component here */}
      </CardContent>
    </Card>
  );
};

export default BillingDashboard;
